const querystring = require('querystring');

// The hosted checkout returns the customer to /process-order?orderId=...;
// the API checks the payment with the gateway and creates the order.
export function verifyReturnedPayment(search, post) {
    const orderId = querystring.parse((search || '').replace(/^\?/, '')).orderId;
    if (!orderId) return Promise.resolve({ ok: false });
    return post('order/verify-payment', { orderId })
        .then((response) => ({ ok: true, order: orderId, receipt: response.data && response.data.ReceiptNo }))
        .catch(() => ({ ok: false }));
}
